import React from 'react';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { SectionPaper } from './SectionPaper';
import { useIsMobile } from '../../api/hooks/isMobile/isMobile';

interface DateRangeFilterProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
  minDate?: Date;
  title?: string;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  minDate,
  title = 'Filter by Date Range',
}) => {
  const isMobile = useIsMobile();
  return (
    <SectionPaper title={title}>
      <Box display={'flex'} flexDirection={isMobile ? 'column' : 'row'} gap={3}>
        <Box width={isMobile ? '100%' : '50%'}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={onStartDateChange}
              sx={{ width: '100%' }}
              maxDate={endDate || undefined}
              minDate={minDate}
            />
          </LocalizationProvider>
        </Box>
        <Box width={isMobile ? '100%' : '50%'}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label="End Date"
              value={endDate}
              onChange={onEndDateChange}
              sx={{ width: '100%' }}
              minDate={startDate || minDate}
            />
          </LocalizationProvider>
        </Box>
      </Box>
    </SectionPaper>
  );
};
